module.exports = __webpack_public_path__ + "img/soldier.c939a1e0.png";